var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 64,
    viewBox: "0 0 53 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4896 34.0351C43.5212 31.5821 44.1728 29.1768 45.3837 27.0432C46.5947 24.9096 48.3257 23.117 50.4156 21.8322C49.0879 19.936 47.3364 18.3756 45.3002 17.2748C43.264 16.1739 40.9991 15.5631 38.6855 15.4907C33.7502 14.9727 28.9656 18.4439 26.4506 18.4439C23.887 18.4439 20.0148 15.5421 15.8452 15.6279C13.1481 15.7151 10.5196 16.4993 8.21578 17.9044C5.91195 19.3094 4.01135 21.2872 2.69917 23.6452C-2.98489 33.4862 1.25491 47.9493 6.69977 55.9041C9.42394 59.7993 12.6077 64.1504 16.7736 63.9961C20.8502 63.827 22.3728 61.3966 27.2936 61.3966C32.1687 61.3966 33.5971 63.9961 37.8476 63.898C42.222 63.827 44.978 59.9855 47.6066 56.0533C49.564 53.2778 51.0701 50.2103 52.0693 46.9644C49.5279 45.8895 47.3591 44.0903 45.8334 41.7911C44.3077 39.4919 43.4926 36.7945 43.4896 34.0351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4616 10.259C37.8467 7.39578 39.0218 3.7156 38.7372 0C35.0933 0.382721 31.7274 2.12426 29.3101 4.87763C28.1282 6.22271 27.223 7.78756 26.6462 9.48269C26.0694 11.1778 25.8324 12.97 25.9487 14.7568C27.7713 14.7756 29.5744 14.3805 31.2222 13.6014C32.87 12.8223 34.3195 11.6795 35.4616 10.259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppStore);
export default __webpack_public_path__ + "static/media/ic-appStore.08e198e87fca5e9565c9062a501b01a1.svg";
export { ForwardRef as ReactComponent };